import { CircularProgress, Grid } from '@mui/material';

import * as Sx from './ProgressIndicator.styles';

export const ProgressIndicator = () => (
  <Grid container sx={Sx.grid}>
    <CircularProgress role="alert" color="secondary" />
  </Grid>
);
